import { render, staticRenderFns } from "./ChangeStaffPwd.vue?vue&type=template&id=19cd34ea&scoped=true"
import script from "./ChangeStaffPwd.vue?vue&type=script&lang=js"
export * from "./ChangeStaffPwd.vue?vue&type=script&lang=js"
import style0 from "./ChangeStaffPwd.vue?vue&type=style&index=0&id=19cd34ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd34ea",
  null
  
)

export default component.exports